import { useState } from "react";
import { checkKeycloakAvailability } from "../../utils/auth/keycloakAvailability";
import { showKeycloakUnavailableAlert } from "../../utils/alerts/authAlerts";
import { appConfig } from "../../utils/config";

export function useSafeLogin({ isLoading, signinRedirect, t, brand }) {
  const [isLoginPending, setIsLoginPending] = useState(false);
  const effectiveBrand = brand || appConfig.brandTheme;

  const login = async (extraQueryParams = {}) => {
    if (isLoading || isLoginPending) {
      return;
    }

    setIsLoginPending(true);

    try {
      const keycloakAvailable = await checkKeycloakAvailability();

      if (!keycloakAvailable) {
        await showKeycloakUnavailableAlert(t);
        return;
      }

      await signinRedirect({
        extraQueryParams: {
          brand: effectiveBrand,
          ...extraQueryParams,
        },
      });
    } catch (error) {
      console.error("Login failed", error);
      await showKeycloakUnavailableAlert(t);
    } finally {
      setIsLoginPending(false);
    }
  };

  return {
    login,
    isLoginPending,
  };
}
